export default __webpack_public_path__ + "static/media/541.f3976cf4.png";